import styled, { css } from 'styled-components';

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));

  ${({ theme: { spacing } }) => css`
    gap: ${spacing?.level3};
  `}

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`;
